import { render, staticRenderFns } from "./PageDelete.vue?vue&type=template&id=493a54bf&scoped=true&"
import script from "./PageDelete.vue?vue&type=script&lang=js&"
export * from "./PageDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a54bf",
  null
  
)

export default component.exports